import { classNames } from "../../functions";
import React from "react";
interface DotsProps {
  children: React.ReactNode;
  className?: string;
}

export default function Dots({ children = <span />, className }: DotsProps) {
  return (
    <>
      <p className={"loading"}>{children} </p>
    </>
  );
}
